import React, { useEffect, useRef, useState } from "react";
import HeadImg from "../../../assets/Dashboard/Header/homepage_hero.webp";
import line2 from "../../../assets/line2.svg";
// import icon2 from "../../../assets/Dashboard/Header/icon2.png";
import icon2 from "../../../assets/new/icon_high_accuracy.svg";
import icon1 from "../../../assets/new/icon_scalability.svg";
// import icon1 from "../../../assets/Dashboard/Header/icon.png";
import logo1 from "../../../assets/Dashboard/Header/download-removebg-preview.png";
// import logo2 from "../../../assets/Dashboard/Header/download1-removebg-preview.png";
import logo2 from "../../../assets/download1.png";
import logo3 from "../../../assets/Dashboard/Header/download2-removebg-preview.png";
import logo4 from "../../../assets/incubix.webp";
// import logo4 from "../../../assets/incubix-unified-solutions-pvt-ltd-mcc-davangere-internet-service-providers-xu3jom8mcy.jpg";

import { BiChevronDown } from "react-icons/bi";
import { Building2, Linkedin, Search, User, Users } from "lucide-react";

const Header = () => {
  const [activeButton, setActiveButton] = useState("byName");
  const [decisionMaker, setDecisionMaker] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);

  const decisionMakerOptions = [
    "CEO/Owner/Director/Function",
    "Vice President",
    "Finance",
    "Human Resources",
    "IT",
    "Logistics",
    "Marketing",
    "Administration",
    "Engineering",
    "Sales",
  ];

  const handlenav = () => {
    window.location.href = process.env.REACT_APP_BASE_URL;
  };

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative bg-[#FFF] max-w-[2000px] mx-auto flex flex-col lg:flex-row items-center lg:items-start px-6 py-10 lg:pt-10 lg:pb-4">
      <div className="lg:w-[51%] text-center lg:text-left space-y-4 lg:space-y-0.5">
        <h1 className="text-3xl !text-[#15233F] sm:text-4xl 2xl:text-nowrap lg:text-[48px] lg:leading-[56px] -mb-3 sm:-mb-0 font-bold lg:ml-6">
          Find Any Real,{" "}
          <span className="relative inline-block">
            Verified
            <img
              src={line2}
              alt="Line decoration"
              className="absolute left-0 bottom-0 lg:-ml-0.5 h-auto top-7 sm:top-9 lg:top-[47px]"
            />
          </span>{" "}
        </h1>
        <h1 className="text-3xl !text-[#15233F] sm:text-4xl 2xl:text-nowrap lg:text-[48px] lg:leading-[56px] font-bold lg:ml-6">
          Email with Guaranteed Delivery
        </h1>

        <div className="flex justify-center pt-1.5 min-[450px]:flex-row flex-col lg:ml-4 items-center lg:justify-start space-x-3 sm:space-x-4 md:space-x-6 font-semibold lg:text-xl lg:pb-1">
          <div className="flex items-center md:space-x-2">
            <img
              src={icon2}
              alt="Effortlessly Managed"
              className="sm:h-12 h-10 w-10 sm:w-12 sm:-mr-1"
            />
            <span>Accurate Results</span>
          </div>
          <div className="flex items-center md:space-x-2">
            <img
              src={icon1}
              alt="Simply Standardised"
              className="sm:h-12 h-10 w-10 sm:w-12 sm:-mr-1"
            />
            <span>Scalable Solutions</span>
          </div>
        </div>

        <div className="flex justify-center pt-6 pb-2">
          <div className="rounded-xl bg-blue-100 border-[1px] border-gray-200 shadow-sm px-4 pb-6 pt-4 space-y-4 sm:w-[600px] min-[700px]:w-full w-72 min-[350px]:w-80 min-[384px]:w-[360px] min-[424px]:w-96 min-[450px]:w-[420px] min-[486px]:w-[450px] min-[514px]:w-[480px] min-[546px]:w-[510px]">
            <div className="text-lg font-semibold mt-1.5 mb-5 text-left sm:text-left">
              Find Email Address
            </div>
            <div className="bg-[#F1F5F9] p-1 rounded-lg !mb-6 space-x-10 lg:space-x-4 2xl:space-x-10 overflow-x-auto whitespace-nowrap scrollbar-hide">
              <div className="relative flex space-x-2 min-[680px]:grid min-[680px]:grid-cols-4 min-[680px]:gap-1">
                <button
                  onClick={() => setActiveButton("byName")}
                  className={`flex items-center justify-center p-1 px-2 ${
                    activeButton === "byName"
                      ? "bg-blue-200 text-black"
                      : "bg-transparent text-gray-600"
                  } hover:bg-white hover:text-black transition-all duration-300 rounded-md z-10`}
                >
                  <User className="h-4 mr-1 flex-shrink-0" />
                  By Name
                </button>
                <button
                  onClick={() => setActiveButton("byCompany")}
                  className={`flex items-center justify-center p-1 px-2 ${
                    activeButton === "byCompany"
                      ? "bg-blue-200 text-black"
                      : "bg-transparent text-gray-600"
                  } hover:bg-white hover:text-black transition-all duration-300 rounded-md z-10`}
                >
                  <Building2 className="h-4 mr-1.5 flex-shrink-0" />
                  By Company
                </button>
                <button
                  onClick={() => setActiveButton("byDecisionMaker")}
                  className={`flex items-center justify-center p-1 px-2 ${
                    activeButton === "byDecisionMaker"
                      ? "bg-blue-200 text-black"
                      : "bg-transparent text-gray-600"
                  } hover:bg-white hover:text-black transition-all duration-300 rounded-md z-10`}
                >
                  <Users className="h-4 mr-1.5 flex-shrink-0" />
                  By Decision
                </button>
                <button
                  onClick={() => setActiveButton("fromLinkedIn")}
                  className={`flex items-center justify-center p-1 px-2 ${
                    activeButton === "fromLinkedIn"
                      ? "bg-blue-200 text-black"
                      : "bg-transparent text-gray-600"
                  } hover:bg-white hover:text-black transition-all duration-300 rounded-md z-10`}
                >
                  <Linkedin className="h-4 mr-1.5 flex-shrink-0" />
                  By LinkedIn ID
                </button>
              </div>
            </div>

            <div className="flex flex-col items-center sm:flex-row">
              {activeButton === "byDecisionMaker" && (
                <div className="relative mb-2 mt-[7px] lg:mt-0 !mr-2 md:mb-0 w-full sm:w-2/3 lg:w-3/5">
                  <button
                    type="button"
                    onClick={toggleDropdown}
                    className="flex justify-between items-center w-full px-3 py-2 border border-gray-300 rounded-lg bg-white text-gray-800 placeholder-gray-500"
                  >
                    <span className="text-left whitespace-nowrap overflow-hidden">
                      {decisionMaker || "Select Decision Maker"}
                    </span>
                    <BiChevronDown className="ml-2" />
                  </button>
                  {dropdownOpen && (
                    <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-10 max-h-60 lg:max-h-[265px] overflow-y-auto scrollbar-hide">
                      <ul className="flex flex-col p-1 space-y-0.5">
                        {decisionMakerOptions.map((option) => (
                          <li
                            key={option}
                            onClick={() => {
                              setDecisionMaker(option);
                              setDropdownOpen(false);
                            }}
                            className="p-2 rounded-lg hover:bg-blue-600 hover:text-white cursor-pointer"
                          >
                            {option}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}

              {activeButton !== "byCompany" &&
                activeButton !== "fromLinkedIn" &&
                activeButton !== "byDecisionMaker" && (
                  <div className="flex flex-col !mr-2 mb-2 md:mb-0 w-full">
                    <input
                      type="text"
                      placeholder="Full name..."
                      className="px-3 mt-[7px] lg:mt-0 py-2 border border-gray-300 rounded-lg w-full bg-white text-gray-800 placeholder-gray-500"
                    />
                  </div>
                )}

              <div className="flex flex-col w-full">
                <input
                  type="text"
                  placeholder={
                    activeButton === "fromLinkedIn"
                      ? "https://www.linkedin.com"
                      : "company.com"
                  }
                  className="px-3 py-2 border border-gray-300 rounded-lg w-full bg-white text-gray-800 placeholder-gray-500"
                />
              </div>

              <button
                onClick={handlenav}
                className={`sm:!ml-2 mt-2 sm:mt-0 w-full text-sm sm:w-auto bg-blue-500 hover:bg-blue-800 text-white rounded-lg font-semibold !px-3 !py-2 flex items-center justify-start`}
                style={{ height: "40px", minWidth: "130px" }}
              >
                <Search className="text-white h-4 w-4 mr-3" />
                Find Email
              </button>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-center lg:items-start lg:flex-row lg:justify-normal lg:ml-7">
          <div className="text-center text-gray-600 font-medium text-sm mt-4 lg:text-left lg:text-xs leading-tight lg:mt-[26px]">
            <p className="inline lg:block">
              <span>Trusted by </span>
              <span className="text-black lg:inline">hundreds </span>
              <span className="lg:block">of companies</span>
            </p>
          </div>
          <div className="flex items-center justify-center">
            <div className="flex space-x-3 lg:space-x-2 lg:mt-5 mt-4 xl:mt-2.5">
              <img
                src={logo1}
                alt="Company 1"
                className="sm:h-[61px] h-9 min-[424px]:h-12 min-[500px]:h-14 lg:h-11 xl:mt-2"
              />
              <img
                src={logo2}
                alt="Company 2"
                className="sm:h-[61px] h-9 min-[424px]:h-12 min-[500px]:h-14 lg:h-11 xl:h-12 xl:mt-2"
              />
              <img
                src={logo3}
                alt="Company 3"
                className="sm:h-[61px] h-9 min-[424px]:h-12 min-[500px]:h-14 lg:h-11 xl:h-12 xl:mt-2"
              />
              <img
                src={logo4}
                alt="Company 4"
                className="sm:h-[26px] mt-4 hidden sm:block min-[424px]:h-9 min-[500px]:h-10 lg:h-5 xl:h-6 xl:mt-5"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="lg:w-[48%] mt-8 lg:mt-7 flex justify-center lg:justify-end">
        <img
          src={HeadImg}
          alt="header"
          className="w-full max-w-sm lg:max-w-xl"
        />
      </div>
    </div>
  );
};

export default Header;
